// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetPriceListResponse

export type WidgetPriceListApiResponse = {
	prices: Record<string, { id: string; name: string; description: string | null; minPax: number; maxPax: number; validMinPax: number; validMaxPax: number; price: number; timePeriods: Record<string, { start: number; end: number }> }>;
};

export type WidgetPriceList = {
	prices: Record<string, { id: string; name: string; description: string | null; minPax: number; maxPax: number; validMinPax: number; validMaxPax: number; price: number; timePeriods: Record<string, { start: number; end: number }> }>;
};

export function hydrateWidgetPriceList(data: WidgetPriceListApiResponse): WidgetPriceList {
	return {
		...data,
		prices: Array.isArray(data.prices) ? {} : data.prices,
	};
}